import { Component, Input, OnDestroy, OnInit } from '@angular/core';

@Component({
    selector: 'app-ef-carousel',
    templateUrl: './ef-carousel.component.html',
    styleUrls: ['./ef-carousel.component.scss'],
    standalone: false
})
export class EfCarouselComponent implements OnInit, OnDestroy {
    @Input() mediaList:Array<{ type: 'image'|'video', url: string, fit?:'cover'|'contain' }>;

    constructor() { }

    isFullscreen = false;

    currentIndex = 0;

    isAutoplayPaused = false;

    private _slideInterval = null;
    private _inactivityTimeout = null;
    private _prefersReducedMotion = false;

    ngOnInit(): void {
        this._prefersReducedMotion = typeof window !== 'undefined'
            && typeof window.matchMedia === 'function'
            && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.isAutoplayPaused = this._prefersReducedMotion;
        this.startInterval();
    }

    private _clearInactivity() {
        if(this._slideInterval != null) {
            clearInterval(this._slideInterval);
            this._slideInterval = null;
        }
        if(this._inactivityTimeout != null) {
            clearTimeout(this._inactivityTimeout);
            this._inactivityTimeout = null;
        }
    }

    ngOnDestroy() {
        this._clearInactivity()
    }

    toggleAutoplay(event?: Event) {
        event?.stopPropagation();
        this.isAutoplayPaused = !this.isAutoplayPaused;
        if(this.isAutoplayPaused) {
            this._clearInactivity();
        }
        else {
            this.startInterval();
        }
    }

    resetInactivity() {
        this._clearInactivity()

        if(this.isAutoplayPaused || this._prefersReducedMotion) return;

        this._inactivityTimeout = setTimeout(() => {
            this._inactivityTimeout = null;
            this.startInterval();
        }, 5000)
    }

    startInterval() {
        if(this.isAutoplayPaused || this._prefersReducedMotion) return;
        if(this._slideInterval != null) return;

        this._slideInterval = setInterval(() => {
            if(this.mediaList != null && this.mediaList.length > 1) {
                // TODO: controllare se il media corrente è un video e se sta andando
                this.currentIndex = (this.currentIndex + 1) % this.mediaList.length;
            }
        }, 5000)
    }

    private _videoPlaying:HTMLVideoElement = null;

    videoTogglePlay(event:MouseEvent) {
        let _video = event.target as HTMLVideoElement;
        if(_video.paused) _video.play();
        else _video.pause()
    }

    onVideoPlay(event:Event) {
        let _video = event.target as HTMLVideoElement;
        if(this._videoPlaying != null) this._videoPlaying.pause();
        this._videoPlaying = _video;
        _video.parentElement.classList.add('EFCarousel-Video--Playing')
        this._clearInactivity();
    }

    onVideoPause(event:Event) {
        let _video = event.target as HTMLVideoElement;
        _video.pause();
        _video.parentElement.classList.remove('EFCarousel-Video--Playing')
        if(this._videoPlaying == _video) {
            this._videoPlaying = null;
            this.resetInactivity();
        }
    }
}
